<template>
  <div class="account-integrations-form">
    <VForm
      :name="name"
      :fields="formData.fields"
      :disabled="!isValid"
      :initialValues="{
        display_drip: getUser.display_drip,
        display_hubspot: getUser.display_hubspot
      }"
      @change="onChange"
    ></VForm>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import VueTypes from "vue-types";
import VForm from "@/components/VForm";
import withForm from "@/mixins/withForm";
import withToasted from "@/mixins/withToasted";

export default Vue.component("AccountIntegrationsForm", {
  props: {
    initialValues: VueTypes.any
  },

  components: {
    VForm,
    withToasted
  },

  mixins: [withForm, withToasted],

  data() {
    return {
      name: "accountIntegrations",
      formData: {
        fields: [
          {
            name: "display_drip",
            label: "Integrate with Drip",
            elementType: "checkbox",
            extraClass: "account-integrations-checkbox"
          },
          {
            name: "display_hubspot",
            label: "Integrate with HubSpot",
            elementType: "checkbox",
            extraClass: "account-integrations-checkbox"
          }
        ]
      }
    };
  },

  methods: {
    onChange(val) {
      this.updateUser({
        values: { [val.name]: val.value },
        onSuccess: () =>
          this.toast("Your settings have been saved!", "success", {
            icon: "check "
          })
      });
    },

    ...mapActions("account", ["updateUser"])
  },

  computed: {
    ...mapGetters("account", ["getUser"])
  }
});
</script>

<style lang="scss" scoped>
.description {
  color: grey;
  margin-top: 10px;
  font-size: 12px;
  font-style: italic;
}
</style>

<style lang="scss">
.account-integrations-form {
  form {
    display: flex;
    flex-direction: column;
  }
}
.v-checkbox.account-integrations-checkbox {
  margin-top: 30px;

  &:last-child {
    margin-top: 20px;
  }
  display: block;

  label {
    margin-left: 15px;
  }
}
</style>
